export default __webpack_public_path__ + "static/logo-skolekino-rod-14e3db13014ad6ad7f9e7f77969012a9.png";